// ABOUTME: Two-column grid layout for the detail page, matching the ManageUser page pattern.
// ABOUTME: Left column holds ScopeNavigator, right column holds EntityContentPanel — both fill their grid tracks.
import React from 'react'

import {DetailLayoutProps} from '../types'

export const DetailLayout: React.FC<DetailLayoutProps> = ({scopeNavigator, children}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1fr_2.5fr] gap-4 mt-4 max-h-[1500px] mb-[52px]">
      <div className="self-start">{scopeNavigator}</div>
      {children}
    </div>
  )
}
